export default __webpack_public_path__ + "static/media/master.7c785c6f.svg";